/* we want all outside scripts to be managed here, so they don't get lost or duplicateed, or forgotten */
import Analytics from './Analytics'

var allScripts = [{
  name: 'sendTo',
  src: "http://embed.sendtonews.com/player2/embedcode.php?fk=k9GwCzzY&cid=6672"
},{
  name:'googleMaps',
  src:'https://maps.googleapis.com/maps/api/js?key=AIzaSyBzDRqc875DrBU4D_t-1ikHo26hNZSoD3E&libraries=visualization'
}]

function find(stringName) {
  for (var i = 0; i < allScripts.length; i++) {
    if (allScripts[i].name === stringName)
      return allScripts[i]
  }
  throw new Error('OutsideScriptManager attempted to load '+ stringName + ' which is not registered');
}

function load(stringName) {

  if (typeof window != 'object')
    return false
  try {
    let scriptOb = find(stringName)

    if (scriptOb.promise instanceof Promise)
      return scriptOb.promise
    scriptOb.promise = new Promise((resolve, reject) => {
      loadOutsideScript(scriptOb, resolve, reject)
    })
    return scriptOb.promise
  } catch (e) {

    Analytics.reportError(e)

  }

}

function loadOutsideScript(scriptOb, resolve, reject) {
  let outsideScript = document.createElement('script');
  outsideScript.onload = resolve
  outsideScript.onerror = function() {
    const e = new Error('OutsideScriptManager failed to load ' +  scriptOb.name)
    Analytics.reportError(e)

  }
  outsideScript.src = scriptOb.src;
  outsideScript.className = "gnm-script";
  document.getElementsByTagName('head')[0].appendChild(outsideScript);
}
if(typeof window === 'object')
  console.log('OutsideScriptManager has started, currently tracking %s scripts', allScripts.length)

export default {
  load
}



// WEBPACK FOOTER //
// ./app/components/custom/ssr/OutsideScriptManager.js